import React from 'react';
import PropTypes from 'prop-types';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';

const StatusRadioGroup = ({ formik }) => {
	return (<FormControl component='fieldset' error={Boolean(formik.errors.vaccinationStatus)}>
		<RadioGroup name='vaccinationStatus' value={formik.values.vaccinationStatus} onChange={formik.handleChange}>
			<FormControlLabel value='1' control={<Radio />} label={<span>I am fully vaccinated.<sup>1</sup></span>} />
			<FormControlLabel value='2' control={<Radio />} label={<span>I am not yet fully vaccinated.<sup>2</sup></span>} />
			<FormControlLabel value='3' control={<Radio />} label={<span>I have not been vaccinated.<sup>3</sup></span>} />
			<FormControlLabel value='4' control={<Radio />} label='I decline to respond.' />
		</RadioGroup>
		<FormHelperText>{formik.touched.vaccinationStatus && formik.errors.vaccinationStatus}</FormHelperText>
	</FormControl>);
};

StatusRadioGroup.propTypes = {
	formik: PropTypes.any
};
export default StatusRadioGroup;